import { render, staticRenderFns } from "./LeaderDept.vue?vue&type=template&id=53318464&"
import script from "./LeaderDept.vue?vue&type=script&lang=js&"
export * from "./LeaderDept.vue?vue&type=script&lang=js&"
import style0 from "./LeaderDept.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports